package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class MemberResponse(
    val id: String,
    val userId: String,
    val username: String,
    val accountId: String,
    val status: String,
    val createdAt: String
)
